// 1. Column Order for Work Order
export const workOrderDefaultColumnsOrder = [
  "Slno",
  "Code",
  "Description",
  "Locn",
  "Unit",
  "Qty",
  "Unit Price",
  "Disc%",
  "Amount",
  "Frac",
  "QNo",
  "OEM",
  "Vat%",
  "Vatamt",
  "Total",
];

// 2. Mapping: Header → Field Name
export const workOrderColumnFieldMap = {
  Slno: "sino",
  Code: "code",
  Description: "description",
  Locn: "location",
  Unit: "unit",
  Qty: "qty",
  "Unit Price": "unitPrice",
  "Disc%": "discountPercent",
  Amount: "amount",
  Frac: "fraction",
  QNo: "qno",
  OEM: "oem",
  "Vat%": "vatPercent",
  Vatamt: "vatAmount",
  Total: "total",
};

// 3. Base Column Generator (reusable exactly like PO)
export const getWorkOrderBaseColumn = (
  field,
  widthMap,
  renderers,
  locationOptions,
  unitOptions
) => {
  const baseConfig = {
    field,
    headerName:
      Object.entries(workOrderColumnFieldMap).find(
        ([, value]) => value === field
      )?.[0] || field,
    width: widthMap?.[field] || 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
  };

  // Numeric fields
  if (
    [
      "qty",
      "unitPrice",
      "discountPercent",
      "amount",
      "fraction",
      "vatPercent",
      "vatAmount",
      "total",
    ].includes(field)
  ) {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderEditableCell(params, field, "number"),
    };
  }

  // Text fields
  if (["code", "description", "oem", "qno"].includes(field)) {
    return {
      ...baseConfig,
      renderCell: (params) => renderers.renderEditableCell(params, field),
    };
  }

  if (field === "location") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "location", locationOptions),
    };
  }

  if (field === "unit") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "unit", unitOptions),
    };
  }

  return baseConfig;
};

  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

// 4. Calculations
export const calculateWorkOrderRow = (item, workOrderData) => {
  const qty = Number(item.qty) || 0;
  const unitPrice = Number(item.unitPrice) || 0;
  const discountPercent = Number(item.discountPercent) || 0;

  const vatPercent = workOrderData?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;

  const gross = qty * unitPrice;
  const discountAmt = gross * (discountPercent / 100);
  const amount = gross - discountAmt;

  const vatAmount = (amount * vatPercent) / 100;
  const total = amount + vatAmount;

  return {
    ...item,
    amount: amount.toFixed(2),
    vatPercent,
    vatAmount: vatAmount.toFixed(2),
    total: total.toFixed(2),
  };
};

export const getWorkOrderVatPercent = (data) => {
  return data?.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;
};

// 5. Required Fields
export const workOrderRequiredFields = [
  "code",
  "description",
  "location",
  "unit",
  "qty",
  "unitPrice",
];

// 6. New Item Template
export const newWorkOrderItem = (id, sino, defaultLocation) => ({
  id,
  sino,
  code: "",
  description: "",
  location: defaultLocation,
  unit: "",
  qty: 0,
  unitPrice: 0,
  discountPercent: 0,
  amount: 0,
  fraction: 0,
  qno: "",
  oem: "",
  vatPercent: VATPERCENTAGE,
  vatAmount: 0,
  total: 0,
  isIncluded: true,
});

// 7. Column Width Percent Defaults
export const workOrderColumnPercents = {
  sino: 5,
  code: 12,
  description: 25,
  location: 10,
  unit: 8,
  qty: 8,
  unitPrice: 10,
  discountPercent: 8,
  amount: 10,
  fraction: 6,
  qno: 8,
  oem: 10,
  vatPercent: 8,
  vatAmount: 8,
  total: 10,
};
const screenCode = "WORK_ORDER";

export const workOrderConfig = {
  defaultColumnsOrder: workOrderDefaultColumnsOrder,
  columnFieldMap: workOrderColumnFieldMap,
  getBaseColumn: getWorkOrderBaseColumn,
  calculateRowValues: calculateWorkOrderRow,
  getVatPercent: getWorkOrderVatPercent,
  requiredFields: workOrderRequiredFields,
  screenCode,
  newItemTemplate: newWorkOrderItem,
  defaultColumnPercents: workOrderColumnPercents,
};

export default workOrderConfig;
